<template>
  <div class="usercenter">
    <div class="main">
      <div v-if="uid == 'null' || uid == '' || uid == null" class="unlogin">
        <div class="unlogin-img"></div>
        <p>您还没有登录，请登录</p>
        <div class="goToLogin_btn" @click="toGoLogin">登录</div>
      </div>
      <div v-else>
        <div v-if="showPage">
          <div class="user-info">
            <div class="logo" :style="userInfo.backgroundimg"></div>
            <span style="font-weight: bold">{{userInfo.nickname}}</span>
            <img v-if="scoreInfo.level_pic_one" class="level_pic" :src="scoreInfo.level_pic_one" @click="toMemberLevel()">
            <!--<div class="ani" @click="goTuCao">-->
              <!--&lt;!&ndash;<a href="https://support.qq.com/products/43614"></a>&ndash;&gt;-->
            <!--</div>-->
            <div class="line-bg"></div>
          </div>
          <div class="scoreInfo" @click="toMyScore()">
            <div class="score">
              <span class="fs-28 score_bg">蟠桃：</span>
              <span class="fs-42">{{scoreInfo.score}}</span>
            </div>
            <span class="scoreBtn" :class="{'signed': scoreInfo.sign_status == 1}">{{scoreInfo.sign_status == 1 ? '今日已签到' : '签到领积分' }}</span>
          </div>
          <div class="recommend" @click="toRecommend" v-if="showRecommend" :style="{backgroundImage: 'url('+ bannerUrl +')'}"></div>
          <div class="list order-list">
            <ul>
              <li style="padding-top: .32rem">
                <a @click="toAddressList">
                  <span class="icon1 icon_adress fl">我的地址</span><span class="icon_arrow_next fr"></span>
                </a>
              </li>
              <li>
                <a @click="toMyComment">
                  <span class="icon1 icon_comments fl">我的评论</span><span class="icon_arrow_next fr"></span>
                </a>
              </li>
              <li>
                <a @click="toMyComplaints">
                  <span class="icon1 icon_complaints fl">我的投诉</span><span class="icon_arrow_next fr"></span>
                </a>
              </li>
              <li>
                <a @click="toMyService">
                  <span class="icon1 icon_cs fl">客服中心</span><span class="icon_arrow_next fr"></span>
                </a>
              </li>
              <li>
                <a @click="toMyCoupons">
                  <span class="icon1 icon_coupons fl">我的优惠券</span><span class="icon_arrow_next fr"></span>
                </a>
              </li>
              <li style="padding-bottom: .32rem">
                <a @click="toShare">
                  <span class="icon1 icon_share fl">邀请有礼</span><span class="icon_arrow_next fr"></span>
                </a>
              </li>
<!--              <li class="mt30">-->
<!--                <a @click="downLoadApp">-->
<!--                  <span class="icon1 icon_download fl">下载俺来也APP</span><span class="icon_arrow_next fr"></span>-->
<!--                </a>-->
<!--                &lt;!&ndash;<a @click="downLoadApp"><span>下载俺来也APP</span><span class="icon_arrow_next fr"></span></a>&ndash;&gt;-->
<!--                &lt;!&ndash;<router-link to="OrderList" class="arrow-right"><span>退出登录</span></router-link>&ndash;&gt;-->
<!--              </li>-->
              <li v-if="!isJdlwHide">
                <a @click="loginOut" style="border-bottom: none;border-top: 1px solid #F5F5F5;padding: .55rem 0 .54rem 0;">
                  <span class="icon1 icon_logout fl">退出登录</span><span class="icon_arrow_next fr"></span>
                </a>
                <!--<a @click="loginOut"><span>退出登录</span><span class="icon_arrow_next fr"></span></a>-->
                <!--<router-link to="OrderList" class="arrow-right"><span>退出登录</span></router-link>-->
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--<footer class="fixed flex">-->
      <!--<router-link to="index"><span class="icon icon-home">首页</span></router-link>-->
      <!--<router-link to="orderlist"><span class="icon icon-order">订单</span></router-link>-->
      <!--<router-link to="usercenter"><span class="icon icon-user on">我的</span></router-link>-->
    <!--</footer>-->
  </div>
</template>

<script>
  import {actions} from '../store/actions'
  // import { MessageBox }  from 'mint-ui';

  export default {
    data () {
      return {
        showPage:false,
        uid: null,
        showRecommend: false,
        bannerUrl: '',//banner图片链接
        activityUrl: '', //活动链接
        isJdlwHide: false,
        scoreInfo: {} //会员积分信息
      }
    },
    computed: {
      userInfo () {
        return this.$store.state.userInfo
      },
      schoolInfo () {
        return this.$store.state.schoolInfo
      },
      wxUid () {
        return this.$store.state.wxUid
      },
      wxLoginToken () {
        return this.$store.state.wxLoginToken
      },
    },
    beforeRouteLeave(to, from, next) {
      if (to.name == 'OrderList') {
        to.meta.isUseCache = false
      }
      // if (to.name == 'TagPage') {
      //   to.meta.isUseCache = true
      // }
      next()
    },
    created () {
      var _this = this
      _this.uid = window.localStorage.getItem('wxUid');
      if(_this.uid && _this.uid != "null" && _this.uid != ''){
        var obj = {
          backgroundImage: "url("+_this.userInfo.avatar+")"
        }
        _this.userInfo.backgroundimg = obj
        _this.isShowRecommend()//是否显示推荐下单领红包的bannner
        _this.showPage = true
        _this.getScoreInfo() // 我的西游积分
      }
      if (_this.$utils.getCookie('source') && _this.$utils.getCookie('source') == 'jdlw') {
        _this.isJdlwHide = true
      }
    },
    methods: {
      /**
       * 发起接入请求
       * @param  {Number} productId  需要接入产品 id
       * @param  {[Object]} data     需要传递的用户信息
       */
      request(productId, data) {
        var form = document.createElement("form");
        form.id = "form";
        form.name = "form";
        document.body.appendChild(form);

        // 设置相应参数
        for (let key in data) {
          var input = document.createElement("input");
          input.type = "text";
          input.name = key;
          input.value = data[key];
          // 将该输入框插入到 form 中
          form.appendChild(input);
        }
        // form 的提交方式
        form.method = "POST";
        // form 提交路径
        form.action = "https://support.qq.com/product/" + productId;
        // 对该 form 执行提交
        form.submit();
        // 删除该 form
        document.body.removeChild(form);
      },
      goTuCao() {
        var data = {
            "nickname": this.userInfo.nickname,
            "avatar": this.userInfo.backgroundimg,
            "openid": this.$store.state.openId,
          },
          productId = 43614; // 把1221数字换成你的产品ID，否则会不成功
          this.request(productId, data);
      },
      isShowRecommend() {
        let _this = this
        actions.recommendBanner(_this, {}, function (res) {
          if(res!=null){
            _this.showRecommend = true
            _this.bannerUrl = res.imageUrl
            let obj = JSON.parse(res.data)
            _this.activityUrl = obj.url;//banner跳转链接
          }else{
            _this.showRecommend = false
          }
        },function(){

        })
      },
      getScoreInfo() {
        let _this = this
        actions.getMyScore(_this, {uid: _this.$store.state.wxUid}, function (res) {
          _this.scoreInfo = res;
        },function(){})
      },
      toMyScore() {
        this.$router.push({name:'MyScore'})
      },
      toMemberLevel() {
        this.$router.push({name:'MemberLevel'})
      },
      toRecommend() {
        let token = this.$store.state.wxLoginToken
        let uid = this.$store.state.wxUid
        let schoolId = this.schoolInfo.schoolId
        let url = this.activityUrl + '?token='+ token + '&uid='+ uid + '&schoolId=' + schoolId
        window.location.href = url
      },
      loginOut: function () {
        var _this = this;
        actions.postSignOut(_this, {token:_this.$store.state.wxToken}, function () {
          var obj = {
            wxUid: ''
          };
          window.localStorage.removeItem('userDefinedMobile')//退出账号清除自定义自提电话
          window.localStorage.removeItem('cartInfo')//退出账号清除购物车信息
          window.localStorage.removeItem('userInfo')
          window.localStorage.removeItem('wxLoginToken')
          _this.$store.commit('changeState', obj);
          _this.$router.push({name: 'TagPage'})

        }, function (data) {
          _this.$messagebox.alert(data.body.message, '');
        })
      },
      toAddressList: function () {
        var _this = this;
        window.localStorage.setItem('fromPage','UserCenter'); //存储fromPage，用来判断页面是否可以选择地址
        _this.$router.push({name:'AddressList'})
      },
      toMyComment:function () {
        var _this = this;
        window.localStorage.setItem('commentType',1);
        _this.$router.push({name:'MyComment'})
      },
      toMyComplaints:function () {
        var _this = this;
        _this.$router.push({name:'MyComplaints'})
      },
      toMyCoupons: function () {
        this.$router.push({name:'MyCoupons'})
      },
      downLoadApp: function () {
        window.location.href = 'https://dl.anlaiye.com'
      },
      toGoLogin: function () {
        this.$utils.toLogin(this);
      },
      toMyService: function () {
        window.location.href = 'https://service.anlaiye.com.cn/service/service/index'
      },
      toShare: function () {
        let token = this.$store.state.wxLoginToken
        let schoolId = this.schoolInfo.schoolId
        window.location.href = this.$utils.getSpliceHost('special') + '/theme/v1/h5/202404/invite/index.html?token='+token+'&schoolId='+schoolId;
      }
    }
  }
</script>
<style scoped>
  .list ul li > a{
    padding: .26rem 0;
  }
</style>



// WEBPACK FOOTER //
// UserCenter.vue?722b9cca